<template>
  <f7-page class="home-page">
    <template #fixed>
      <MainHeaderComponent />
    </template>

    <div class="bg-gray title-container">
      <div class="title">
        <font-awesome-icon :icon="['fad', 'chart-area']" fixed-width />
        <div class="text">
          <h1>{{ $t.getTranslation("TTL_REDEEM_COUPON_CODE") }}</h1>
          <h3></h3>
        </div>
      </div>

      <div v-show="false" class="button-container">
        <f7-button large fill raised>Actions</f7-button>
        <f7-button large icon="far fa-fw fa-cog"></f7-button>
      </div>

      <div class="button-container">
        <f7-button large fill raised @click="create">{{ $t.getTranslation("LBL_CREATE") }}</f7-button>
      </div>
    </div>

    <DataTableComponent :columns="columns" :size="10" :url="url" @editItem="editItem" @viewOrders="viewOrders"></DataTableComponent>

    <MainFooterComponent />
  </f7-page>
</template>

<script>
import { defineComponent, inject, computed } from "vue";

import MainHeaderComponent from "@/components/MainHeaderComponent.vue";
import MainFooterComponent from "@/components/MainFooterComponent.vue";
import DataTableComponent from "@/components/DataTableComponent.vue";
import { useStore } from "@/store";
import { $HTTP } from "@/utils/axios";
import { helpers } from "@/utils/helpers";
export default defineComponent({
  name: "BlankPage",
  components: {
    MainHeaderComponent,
    MainFooterComponent,
    DataTableComponent,
  },
  props: { f7router: Object },
  setup(props) {
    const $t = inject("$translation");
    const store = useStore();

    const columns = [
      {
        title: $t.getTranslation("LBL_COUPON_ID"),
        minWidth: 160,
        field: "VoucherId",
      },
      {
        title: $t.getTranslation("LBL_CRITERIA"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
                Coupon Code
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_STATUS"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
              <div class="chip ${cell.getData()?.StatusCode === "ACTIVE" ? "color-green" : "color-gray"}">
                <div class="chip-label">${cell.getData()?.StatusName || "--"}</div>
              </div>
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_COUPON_CODE"),
        minWidth: 160,
        field: "RedeemCode",
      },
      {
        title: $t.getTranslation("LBL_COUPON_AMOUNT"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
                ${cell.getData().AmountType == "FIXED" ? helpers.formatPrice(cell.getData().Amount, "RMB") : cell.getData().Amount + "% OFF"}
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_VALID_FROM"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
                ${helpers.formatDateTime(cell.getData().StartDate)}
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_VALID_TO"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
                ${helpers.formatDateTime(cell.getData().EndDate)}
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_MIN_ORDER_AMOUNT"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
                ${helpers.formatPrice(cell.getData().MinOrderAmount, "RMB")}
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_TOTAL_COUPON_QTY"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
                ${cell.getData().AssignedQty ? helpers.formatNumber(cell.getData().AssignedQty) : $t.getTranslation("LBL_UNLIMITED")}
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_TOTAL_USAGE_PER_USER"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
                ${cell.getData().PerUserUsage ? helpers.formatNumber(cell.getData().PerUserUsage) : $t.getTranslation("LBL_UNLIMITED")}
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_REDEEM_QTY"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
                ${helpers.formatNumber(cell.getData().ReedemQty)}
            </div>
          `;
        },
      },
      {
        title: $t.getTranslation("LBL_DATE_CREATED"),
        minWidth: 160,
        formatter(cell) {
          return `
            <div>
              ${helpers.formatDateTime(cell.getData().LastCreated)}
            </div>
          `;
        },
      },
    ];

    const editItem = (data) => {
      if (data?.value?.VoucherId) {
        props.f7router.navigate({ name: "voucherCodeSave", query: { VoucherId: data.value.VoucherId } });
      }
    };

    const viewOrders = (data) => {
      if (data?.value?.VoucherId) {
        props.f7router.navigate({ name: "voucherOrders", query: { VoucherId: data.value.VoucherId } });
      }
    };

    const create = () => {
      props.f7router.navigate({ name: "voucherCodeSave", query: {} });
    };

    let url = `/admin/voucher/code/list`;
    return {
      viewOrders,
      columns,
      url,
      editItem,
      create,
    };
  },
});
</script>

<style scoped>
.custom-container {
  min-height: 600px;
}
</style>
